import { M365AcquisitionsDocument } from "owa-m365-acquisitions/lib/graphql/query/__generated__/M365Acquisitions.interface";
import { getBootM365Acquisitions, toBootM365AcquisitionsQuery, } from "owa-m365-acquisitions/lib/getBootM365Acquisitions";
import { lazyGetM365Acquisitions } from "owa-m365-acquisitions/lib/lazyFunction";
import { errorThatWillCauseAlert } from "owa-trace";
import { writeQuery } from "owa-apollo";
import type { MailboxInfo } from "owa-client-types";
import checkFeatureFlagLoadStateForMailboxInfo from "owa-feature-flags/lib/utils/checkFeatureFlagLoadStateForMailboxInfo";
import { lazyGovern, GovernPriority } from "owa-tti";
import { getGlobalSettingsAccountMailboxInfo, isGlobalSettingsMailbox, } from "owa-account-source-list-store";

export async function bootstrapM365AcquisitionsCache(mailboxInfoInput?: MailboxInfo): Promise<void> {
    try {
        const mailboxInfo = mailboxInfoInput ?? getGlobalSettingsAccountMailboxInfo();
        const { acquisitions: m365Acquisitions, usedFallback } = await getBootM365Acquisitions(mailboxInfo);
        
        // check if feature flags are loaded for the account associated with the mailboxInfo
        checkFeatureFlagLoadStateForMailboxInfo("M365AcquisitionsWrite", mailboxInfo);
        writeQuery(M365AcquisitionsDocument, {
            data: toBootM365AcquisitionsQuery(m365Acquisitions),
            variables: {
                mailboxInfo,
            },
        });
        
        // If we had to use the fallback cache for acquisitions instead of startupdata for the primary account,
        // we should trigger a network call to get the latest acquisitions as the fallback cache can be stale.
        if (usedFallback && isGlobalSettingsMailbox(mailboxInfo)) {
            lazyGovern.importAndExecute({
                task: () => lazyGetM365Acquisitions.importAndExecute("network-only", undefined, mailboxInfo),
                priority: GovernPriority.Idle,
                name: "lazyGetM365Acquisitions_refresh",
                // Generated by Copilot. Please update with the correct owners.
                ownership: ["elvonspa@microsoft.com"],
            });
        }
    }
    catch (e) {
        // Errors resulting from enabling useUnknownInCatchVariables
        // TS2345: Argument of type 'unknown' is not assignable to parameter of type 'TraceErrorObject | undefined'.
        // @ts-expect-error
        errorThatWillCauseAlert("M365Acquisitions_CachePriming_Error", e);
    }
}
